import { Link } from "react-router-dom";
import { newsData } from "../../../mocks/news";

function NewsCard({ item }: { item: typeof newsData[0] }) {
  return (
    <Link to="/" className="group cursor-pointer block">
      <article>
        {/* Image */}
        <div className="relative overflow-hidden aspect-video mb-5">
          <img
            src={item.image}
            alt={item.title}
            width={800}
            height={450}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute top-3 right-3 bg-white px-3 py-1">
            <span className="text-xs font-medium text-stone-800 tracking-widest"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}>
              {item.date}
            </span>
          </div>
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" />
        </div>

        {/* Content */}
        <div className="space-y-2">
          <span className="text-xs tracking-[0.25em] text-amber-700 font-medium"
                style={{ fontFamily: "'DM Sans', sans-serif" }}>
            {item.category}
          </span>
          <h3
            className="text-lg font-semibold text-stone-900 leading-snug line-clamp-2 group-hover:text-amber-800 transition-colors duration-300"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            {item.title}
          </h3>
          <p className="text-xs text-stone-400 leading-snug line-clamp-1 italic"
             style={{ fontFamily: "'DM Sans', sans-serif" }}>
            {item.titleEn}
          </p>
          <p className="text-sm text-stone-500 leading-relaxed line-clamp-2"
             style={{ fontFamily: "'DM Sans', sans-serif" }}>
            {item.excerpt}
          </p>
          <p className="text-xs text-stone-400 leading-relaxed line-clamp-2 italic"
             style={{ fontFamily: "'DM Sans', sans-serif" }}>
            {item.excerptEn}
          </p>
          <div className="flex items-center gap-2 pt-2">
            <span className="text-xs tracking-[0.15em] text-stone-800 font-medium"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}>
              READ MORE · 阅读更多
            </span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm text-stone-800" />
            </div>
          </div>
        </div>
      </article>
    </Link>
  );
}

export default function NewsSection() {
  return (
    <section id="news" className="py-28 px-8 lg:px-20 bg-white">
      <div className="max-w-screen-xl mx-auto">
        {/* Header */}
        <div className="flex items-end justify-between mb-16">
          <div>
            <p className="text-xs tracking-[0.35em] text-stone-400 mb-3"
               style={{ fontFamily: "'DM Sans', sans-serif" }}>
              LATEST UPDATES · 最新动态
            </p>
            <h2
              className="text-6xl font-black text-stone-900 leading-none"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              NEWS <span className="text-4xl text-stone-400">· 新闻</span>
            </h2>
          </div>
          <Link
            to="/"
            className="hidden lg:flex items-center gap-3 border border-stone-900 px-8 py-3 text-xs tracking-[0.2em] text-stone-900 hover:bg-stone-900 hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            VIEW ALL NEWS · 查看全部新闻
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </div>
          </Link>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {newsData.map((item) => (
            <NewsCard key={item.id} item={item} />
          ))}
        </div>

        {/* Mobile Button */}
        <div className="lg:hidden mt-12 flex justify-center">
          <Link
            to="/"
            className="flex items-center gap-3 border border-stone-900 px-8 py-3 text-xs tracking-[0.2em] text-stone-900 hover:bg-stone-900 hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            VIEW ALL NEWS · 查看全部新闻
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
